module.exports = "  <div class=\"alert alert-warning\" role=\"alert\">\n    {{message}}\n  </div>\n\n"